export const developer = {
  developers: 'Zhvillues',
  enpowerYourDevelopersToHarnessTheFullPotential: 'Forco zhvilluesit tuaj për të përdorur potencialin e plotë të panelit tuaj',
  accessToken: 'Token i Hyrjes',
  yourAPI: 'API-tuaja',
  api: {
    apiManagement: 'Menaxhimi i API-ve',
    apiManagementSubHeading: 'Shtoni, konfiguroni, testoni dhe menaxhoni API-tuaja që mund të përdorni për të shpërthyer në rrjedhën tuaj të bisedës.',
    addApi: 'Shto API',
    createApi: 'Krijo një API',
    noApiFound: 'Nuk u gjet API!',
    deleteApis: 'Fshi API-t',
    areYouSureYouWantToDeleteAPI: `A jeni i sigurt që dëshironi të fshini API-të`,
    placeholders: {
      search: `Kërko sipas emrit të API-s`
    },
    tableHead: {
      method: 'Metoda',
      apiName: 'Emri i API-s',
      url: 'URL',
      actions: 'Veprimet'
    },
    parametersTab: 'Parametrat',
    headersTab: 'Headers',
    bodyTab: 'Body Tab',
    manageApiResponses: 'Menaxho Përgjigjet e API-s',
    chooseVariableToSave: 'Zgjidh variablën për të ruajtur',
    selectCustomAttribute: 'Zgjidh atributin e përshtatur',
    subTab: {
      key: 'Çelësi',
      enterKey: 'Vendos Çelësin',
      value: 'Vlera',
      enterValue: 'Vendos Vlerën',
      addAnotherField: 'Shto një fushë tjetër',
      save: 'Ruaj',
      useslashToInsertCustomVariables: `Përdorni ‘/’ për të futur variablat e përshtatura ose vlerat dinamike nga përgjigja e përdoruesit.`,
      response: 'Përgjigja',
      apiRequestBody: 'Trupi i Kërkesës së API-s',
      hit: 'Gjuaj',
      test: 'Testo',
      buttonToGetAResponse: 'butoni për të marrë një përgjigje',
      variable: 'Variabël',
      saveToCustomAttribute: 'Ruaj në Atributin e Përshtatur',
      encryptedKey: 'Çelës (i enkriptuar)',
      noOptionsAvailable: 'Asnjë opsion i disponueshëm',
      addAuthenticationField: 'Shtoni Fushën e Autentikimit'
    },
    apiLogs: {
      apiManagement: 'Menaxhimi i API-ve',
      addConfigureTestAndManageYourAPIs: 'Shtoni, konfiguroni, testoni dhe menaxhoni API-tuaja që mund të përdorni për të shpërthyer në rrjedhën tuaj të bisedës.',
      searchHere: 'Kërko sipas kodit të statusit',
      deleteApis: 'Fshi API-t',
      testAnApi: 'Testo një API',
      noAPILogFound: 'Nuk u gjet asnjë regjistër API',
      responseCode: 'Kodi i Përgjigjes',
      message: 'Mesazhi',
      apiResponse: 'Përgjigja e API-s',
      actions: 'Veprimet',
      deleteAPIs: 'Fshi Regjistrat e API',
      areYouSureYouWantToDelete: 'A jeni i sigurt që dëshironi të fshini këtë Regjistër API?',
      apiLogs: 'Regjistrat e API-s',
      subTitle: 'Regjistrim i detajuar i të gjitha kërkesave dhe përgjigjeve të API-ve të shpërthyera brenda rrjedhës së bisedës së chatbot-it.'
    }
  },
  configApi: {
    configureApi: `Konfiguro API-n`,
    configureApiSubHeading: `Mund të konfiguroni API-n tuaj bazuar në JSON këtu dhe përdorni për të pasuruar rrjedhën tuaj të bisedës`,
    apiLogs: `Regjistrat e API-s`,
    test: `Testo`,
    manageApiResponse: `Menaxho Përgjigjet e API-s`,
    body: `Trupi`,
    headers: `Headers`,
    parameters: `Parametrat`,
    testyourRequest: 'Testoni Kërkesën Tuaj',
    testRequestDescription: 'Kërkesa juaj përmban variabla, mund të vendosni vlerat e tyre manualisht për qëllime testimi.',
    apiName: 'Emri i API',
    placeholders: {
      enterApiName: `Vendos Emrin e API-s`,
      enterApiUrl: `Vendos URL-n e API-s`,
      enterTestValue: 'Vendos Vlerën e Testit'
    }
  }
};
